var LayerSelectorOverlay = function (data, opts) {};

module.exports = LayerSelectorOverlay;



//////////////////
// WEBPACK FOOTER
// ./~/internal-carto.js/src/vis/overlays/layer_selector.js
// module id = 1694
// module chunks = 6